import { useTranslation } from 'react-i18next';
import { Fragment, useMemo } from 'react';

import _ from 'lodash';

import { useFlightTicketRequests } from 'entities/Flights/sdk';

import Navigation from 'components/Navigation';
import PageContent from 'components/PageContent';
import PageTitle from 'components/PageTitle';
import FlightBox from 'pages/Flights/FlightBox';
import Title from 'pages/Flights/Title';
import { FlightTicketProposalStatusEnum } from 'utils/constants';
import Footer from 'components/Footer';

const Flights = () => {
  const { t } = useTranslation();
  const { data: flightTicketRequests } = useFlightTicketRequests();

  const upcomingFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status !== FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  const pastFlights = useMemo(
    () =>
      _.filter(
        flightTicketRequests,
        (flightTicketRequest) => flightTicketRequest.computed_status === FlightTicketProposalStatusEnum.OPERATED
      ),
    [flightTicketRequests]
  );

  return (
    <Fragment>
      <Navigation />
      <PageContent>
        <PageTitle text={t('flights.title')} />
        <div className='pt-[28px] flex flex-col gap-[8px]'>
          <Title text={t('flights.upcoming')} />
          <div className='flex flex-row gap-6 max-lg:flex-col'>
            {_.map(upcomingFlights, (flightTicketRequest, index) => (
              <FlightBox key={index} flightTicketRequest={flightTicketRequest} />
            ))}
          </div>

          {!_.isEmpty(pastFlights) && (
            <Fragment>
              <Title text={t('flights.past')} />{' '}
              <div className='flex flex-row gap-6 max-lg:flex-col'>
                {_.map(pastFlights, (flightTicketRequest) => (
                  <FlightBox flightTicketRequest={flightTicketRequest} />
                ))}
              </div>
            </Fragment>
          )}
        </div>
      </PageContent>
      <Footer />
    </Fragment>
  );
};

export default Flights;
